const APP_URLS = {
    scanQR: '/scan-qr',
    gatewayDetectedWithGateway: '/gateway-detected/:gateway',
}

export default APP_URLS
